import React from "react";
import { Grid } from "@mui/material";
import { Product } from "utils/types/ProductTypes";
import { ProductCard } from "./ProductCard";

interface ProductListProps {
  products?: Product[];
  loading?: boolean;
  skeletonCount?: number;
}

export const ProductList: React.FC<ProductListProps> = ({
  products,
  loading = false,
  skeletonCount = 8,
}) => {
  const list: Array<Product | undefined> = loading
    ? Array.from({ length: skeletonCount }, () => undefined)
    : Array.isArray(products)
    ? products
    : [];


  if (!loading && !Array.isArray(products)) {
    console.warn("[ProductList] products is not an array:", products);
  }

  return (
    <Grid
      container
      spacing={3}
      justifyContent="center"
      sx={{ p: { xs: 1, sm: 2, md: 3 } }}
    >
      {list.map((product, index) => (
        <Grid
          item
          key={(product as Product)?.id ?? `skeleton-${index}`}
          xs={12}
          sm={6}
          md={4}
          lg={3}
        >
          {/* ProductCard doit supporter `loading` et un product potentiellement null */}
          <ProductCard product={product} loading={loading} />
        </Grid>
      ))}
    </Grid>
  );
};
